import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const ManipalSignalWalletList = Loadable(
	lazy(() =>
		import("./ManipalSignalWalletList").then(({ ManipalSignalWalletList }) => ({
			default: ManipalSignalWalletList,
		}))
	)
);

export const manipalSignalWalletRoutes = [
	{
		path: "/manipal-signal-wallet",
		exact: true,
		element: (
			<AuthorizedRoute
				moduleIds={[ALLOWED_MODULES.CUSTOMER]}
			>
				<ManipalSignalWalletList />
			</AuthorizedRoute>
		),
	},
];
